import apiClient, { unwrap } from './client'
import type { QueueItem, QueueStats } from './types'

export const queueApi = {
  list(status?: string, limit = 100) {
    const params: Record<string, unknown> = { limit }
    if (status) params.status = status
    return unwrap<QueueItem[]>(apiClient.get('/queue', { params }))
  },

  stats() {
    return unwrap<QueueStats>(apiClient.get('/queue/stats'))
  },

  retry(id: string) {
    return unwrap<{ retried: boolean }>(apiClient.post(`/queue/${id}/retry`))
  },

  delete(id: string) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/queue/${id}`))
  },
}
